import React, { useRef } from 'react'
import { chipImg, frameImg, frameVideo } from '../utils'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { animateWithGsap } from '../utils/animation'

const Chip = () => {
    const videoref = useRef();

    useGSAP(()=>{
        gsap.from('#chip',{
            scrollTrigger:{
                trigger:'#chip',
                start:'20% bottom'
            },
            opacity:0,
            scale:2,
            duration:2,
            ease:'power2.inOut'
        })

        animateWithGsap('.g_fadeIn',{
            opacity:1,
            y:0,
            duration:1,
            ease:'power2.inOut'
        })
    },[])
  return (
    <section className='common-padding'>
        <div className='screen-max-width'>
            <div id='chip' className='flex-center w-full my-20'>
               <img src={chipImg} alt="chip"  width={100} height={100}/>
            </div>
            <div className='flex flex-col items-center'>
                <h2 className='hiw-title'>A17 Pro Chip
                    <br />A Monster For Gaming
                </h2>
                 <p className='hiw-subtitle'>
                It's here. The Biggest redesign in the history of Apple GPUs.
            </p>
            </div>
             <div className='mt-10 md:mt-20 mb-14'>
                <div className='relative h-full flex-center'>
                    <div className='overflow-hidden'>
                        <img src={frameImg} alt="frame" className='bg-transparent relative z-10' />
                    </div>
                        <div className='hiw-video'>
                            <video className='pointer-events-none ' playsInline preload='none' muted autoPlay ref={videoref} >
                                <source src={frameVideo} type='video/mp4'/>
                            </video>
                        </div>
                </div>
                </div>
                <p className='text-gray font-semibold text-center mt-3'>Honkai: Star Rail</p>

                <div className="hiw-text-container mt-10 ">
                <div className="flex flex-1 justify-center flex-col gap-3">
                    <p className="hiw-text g_fadeIn"> A17 Pro is an entirely new class of iphone chip that delivers our {' '}
                        <span className="text-white">Best Graphic Perfomance By far.</span>
                       
                    </p>
               
                
                    <p className="hiw-text g_fadeIn"> Mobile {' '}
                        <span className="text-white">Games will look so Emmersive { ' '}</span>
                        with encrideble detailed environment and envirnment
                       
                    </p>
                
                </div>
             
              <div className='flex-1 flex flex-col justify-center g_fadeIn'>
                <p className="hiw-text">New</p>
                <p className="hiw-bigtext">Pro-Class Gpu</p>
                <p className="hiw-text">With 6 Cores</p>
              </div>
             </div>
         </div>

    </section>
  )
}

export default Chip
